/* eslint-disable camelcase */

export default class DtoPgsseDiagnosticWithDanger {
    constructor(obj) {
        this.idDiag = obj.idDiag // Option[Long],
        this.idContributor = obj.idContributor // Option[Long],
        this.idSector = obj.idSector // Option[Long],
        this.idUdi = obj.idUdi // Option[Long],
        this.lowRisk = obj.lowRisk // Option[Int],
        this.mediumRisk = obj.mediumRisk // Option[Int],
        this.highRisk = obj.highRisk // Option[Int],
        this.residualRisk = obj.residualRisk // Option[Int]
    }
}


